import { useEffect } from "react";
import { getFeaturedArticles } from "@/mocks/news";
import Hero from "./components/Hero";
import CategoryFeed from "./components/CategoryFeed";
import HotTopic from "./components/HotTopic";
import ChannelNav from "./components/ChannelNav";
import ScoopCta from "./components/ScoopCta";
import FaqSection, { faqs } from "./components/FaqSection";

const siteUrl = "https://budingmh.com.cn";

export default function Home() {
  useEffect(() => {
    document.title =
      "每日爆料官网_今日最新即时快讯_新鲜猛料实时更新";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute(
        "content",
        "每日爆料官网实时更新今日最新爆料，涵盖娱乐、社会、财经等热门事件，即时快讯第一时间送达，让你快速掌握刚刚发生的新鲜猛料，随时刷新获取全网最新消息。"
      );
    }
  }, []);

  const featured = getFeaturedArticles();

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: "每日爆料",
        url: siteUrl,
        description: "每日爆料今日最新即时快讯，涵盖娱乐、社会、财经等热门事件。",
        potentialAction: {
          "@type": "SearchAction",
          target: `${siteUrl}/?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "CollectionPage",
        name: "每日爆料 - 今日最新即时快讯",
        description: "每日爆料实时更新的今日最新爆料与即时快讯，聚焦娱乐、社会、财经等热门事件。",
        url: siteUrl,
        mainEntity: {
          "@type": "ItemList",
          itemListElement: featured.map((a, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: a.title,
            url: `${siteUrl}/news/${a.id}`,
          })),
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Hero />
      <CategoryFeed />
      <HotTopic />
      <ChannelNav />
      <ScoopCta />
      <FaqSection />
    </>
  );
}